@if (formAssistance) {
  <div class="assistance-form-container">
    @if (!isTravel) {
      <div class="title-container">
        <h2>{{ formType === 'general' ? ('assistanceForm.title_generic' | translate) : ('assistanceForm.title_covid' | translate) }}</h2>
        <h3>{{ 'assistanceForm.enter_question' | translate }}</h3>
        <p>{{ 'assistanceForm.subtitle' | translate }}</p>
      </div>
    } @else {
      <div class="title-container">
        <h3>{{ 'assistanceForm.travel' | translate }}</h3>
      </div>
    }

    <div class="form-container" nz-row [ngClass]="{ 'no-padding': isTravel }">
      <ng-container [formGroup]="formAssistance">
        @if (formType === 'general') {
          <p>{{ 'assistanceForm.are_you_traveling' | translate }}</p>
          <nz-radio-group [formControlName]="'travel'">
            <label nz-radio [nzValue]="true">{{ 'assistanceForm.yes' | translate }}</label>
            <label nz-radio [nzValue]="false">{{ 'assistanceForm.no' | translate }}</label>
          </nz-radio-group>

          @if (formAssistance.get('destination') && formAssistance.get('departure') && formAssistance.get('return')) {
            <div class="datepicker-container" nz-row>
              <div class="datepicker-element" nz-col [nzXl]="7" [nzLg]="24" [nzXs]="24" [nzMd]="24">
                <span>{{ 'assistanceForm.departure' | translate }}</span>
                <nz-date-picker
                  nzId="departure"
                  [formControlName]="'departure'"
                  [nzPlaceHolder]="'assistanceForm.select_date' | translate"
                  nzFormat="dd-MM-yyyy"
                  nzShowToday
                  [nzAllowClear]="false"
                  [nzDisabledDate]="checkDisabledDateStart"
                ></nz-date-picker>
              </div>
              <div class="datepicker-element" nz-col [nzXl]="7" [nzLg]="24" [nzXs]="24" [nzMd]="24">
                <span>{{ 'assistanceForm.return' | translate }}</span>
                <nz-date-picker
                  nzId="return"
                  [formControlName]="'return'"
                  [nzPlaceHolder]="'assistanceForm.select_date' | translate"
                  nzFormat="dd-MM-yyyy"
                  nzShowToday
                  [nzAllowClear]="false"
                  [nzDisabledDate]="checkDisabledDateEnd"
                ></nz-date-picker>
              </div>
            </div>

            <ds-select
              nz-col
              [nzXl]="7"
              [nzLg]="24"
              [nzXs]="24"
              [nzMd]="24"
              [placeholder]="'assistanceForm.select' | translate"
              [label]="'assistanceForm.destination' | translate"
              [texts]="descriptionCountry"
              [values]="codeCountry"
              [control]="formAssistance.get('destination')"
            ></ds-select>
          }
        }
        @if (!isTravel) {
          <ds-input-text
            nz-col
            [type]="'number'"
            [nzXl]="7"
            [nzLg]="24"
            [nzXs]="24"
            [nzMd]="24"
            [control]="formAssistance.get('telephone')"
            [placeholder]="'assistanceForm.insert' | translate"
            [label]="'assistanceForm.telephone' | translate"
          >
          </ds-input-text>
          <ds-input-area
            nz-col
            [nzXl]="7"
            [nzLg]="24"
            [nzXs]="24"
            [nzMd]="24"
            [control]="formAssistance.get('message')"
            [placeholder]="'assistanceForm.insert' | translate"
            [label]="'assistanceForm.request_message' | translate"
          >
          </ds-input-area>
        }
      </ng-container>
    </div>
    <div class="button-container" [hidden]="isTravel">
      <ds-button class="button-request" text="{{ 'buttons.request' | translate }}" [isDisabled]="formAssistance.invalid" [width]="'small'" (click)="sendRequest()"></ds-button>
    </div>
  </div>
}
